
import { useContext } from "react";
import { DataContext } from "../data/DataContext"
import { DropDown, Input } from '../components'

const StepDataContent = () => {
    const { IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 } = useContext(DataContext);

    const ChangeHandlerCountry = (property: string, value: any) => {
        if (value === undefined) return;
        const country = IHContenidoSeguroCR.catCanton.find(x => x.value === value);
        SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, [property]: value, riskZone: country?.inZonaRiesgo ?? 0 });     
    }

    return <>
        <DropDown
            dataProvider={IHContenidoSeguroCR.catProvince}
            field='province'
            label='Provincia'
            id='province'
            valueSelect={IHContenidoSeguroCR.province}
            onChangeSelect={ChangeHandler2}
        />
        <DropDown
            dataProvider={IHContenidoSeguroCR.catCanton}
            field='canton'
            label='Cantón'
            valueSelect={IHContenidoSeguroCR.canton}
            onChangeSelect={ChangeHandlerCountry}
        />
        <DropDown
            dataProvider={IHContenidoSeguroCR.catDistrict}
            field='district'
            label='Distrito'
            valueSelect={IHContenidoSeguroCR.district}
            onChangeSelect={ChangeHandler2}
        />
        <DropDown
            dataProvider={IHContenidoSeguroCR.catNeighborhood}
            field='neighborhood'
            label='Barrio'
            valueSelect={IHContenidoSeguroCR.neighborhood}
            onChangeSelect={ChangeHandler2}
        />
        <Input
            field='addressRisk'
            id='addressRisk'
            label='Dirección del riesgo'
            onChange={ChangeHandler}
            value={IHContenidoSeguroCR.addressRisk}
            type='textarea'
        />
    </>
}

export { StepDataContent }